<template>
  <div class="wrapper">
    <!-- 头部标题 -->
    <page-head title="防疫统计" :showBack="false"></page-head>
    <div class="content">
      <Tabs>
        <TabPane label="电子场所码">
          <div>
            <page-head
              title="电子场所码"
              :btn-list="btnList"
              :show-back="false"
              @handleBtn="handleBtn"
            ></page-head>
          </div>
          <div class="content">
            <div class="box_f1 box_v wrapper1">
              <i-form ref="search" :model="query">
                <row :gutter="80">
                  <i-col span="6">
                    <form-item label="乡街">
                      <Cascader
                        v-model="comList"
                        :data="communityList"
                        placeholder="请选择"
                        clearable
                        @on-change="communityChange"
                        change-on-select
                      ></Cascader>
                    </form-item>
                  </i-col>

                  <i-col span="6">
                    <form-item label="单位" prop="companyName">
                      <Input
                        v-model="query.companyName"
                        clearable
                        placeholder="请输入单位名称"
                      />
                    </form-item>
                  </i-col>

                  <i-col span="6">
                    <form-item label="姓名" prop="realName">
                      <Input
                        v-model="query.realName"
                        clearable
                        placeholder="请输入姓名"
                      />
                    </form-item>
                  </i-col>

                  <i-col span="6">
                    <form-item label="电话" prop="phoneNO">
                      <Input
                        v-model="query.phoneNO"
                        clearable
                        placeholder="请输入电话"
                      />
                    </form-item>
                  </i-col>

                  <i-col span="6">
                    <form-item label="出入时间段" prop="time">
                      <DatePicker
                        v-model="time"
                        class="time"
                        type="daterange"
                        placeholder="请选择出入时间段"
                      ></DatePicker>
                    </form-item>
                  </i-col>

                  <i-col span="6">
                    <form-item label="最低体温" prop="minTemperature1">
                      <Input
                        v-model="query.minTemperature1"
                        clearable
                        placeholder="请输入最低体温"
                      />
                    </form-item>
                  </i-col>

                  <i-col span="6">
                    <form-item label="最高体温" prop="maxTemperature1">
                      <Input
                        v-model="query.maxTemperature1"
                        clearable
                        placeholder="请输入最高体温"
                      />
                    </form-item>
                  </i-col>
                </row>
              </i-form>
            </div>
          </div>

          <div class="content">
            <div class="box_f1 box_v">
              <div class="table-data">
                <i-table
                  :columns="tableHeader"
                  :border="true"
                  :data="tableData"
                  :loading="isLoading"
                  stripe
                  ref="table"
                >
                </i-table>
                <div class="page">
                  <page
                    :total="total"
                    :current="pageNum"
                    @on-change="pageChange"
                    show-total
                  />
                </div>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="入户统计人员报表-小区(格式)">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/cttPersonRegisterCountByHousingFormat.cpt&communityId=' +
              communityId +
              '&levelId=' +
              levelId
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="扫描电子场所码进出记录统计表">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/cttPersonRegisterWalkRecordCountByCompany.cpt&path=' +
              path
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="电子场所码统计报表">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/cttPersonRegisterCompanyCountByStreet.cpt&path=' +
              path
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="入户统计人员报表-街道">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/cttPersonRegisterCountByStreet.cpt&communityId=' +
              communityId +
              '&levelId=' +
              levelId
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="入户统计人员报表-小区">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/cttPersonRegisterCountByHousing.cpt&communityId=' +
              communityId +
              '&levelId=' +
              levelId
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="入户统计人员报表-社区">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/cttPersonRegisterCountByCommunity.cpt&communityId=' +
              communityId +
              '&levelId=' +
              levelId
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>

        <TabPane label="登记信息">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/ncov.cpt&communityId=' +
              communityId
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="自排查表">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/ncovcheck.cpt&communityId=' +
              communityId
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="出入统计">
          <iframe
            class="iframebox"
            :style="{ height: height + 'px' }"
            :src="
              head +
              '/decision/view/report?viewlet=/jczl/ncovinout.cpt&communityId=' +
              communityId
            "
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";

const { getWalkRecordList, exportWalkRecordList } = api;
const WALKTYPEMAP = {
  in: {
    walkType: "进门",
  },
  out: {
    walkType: "出门",
  },
  "vistor-in": {
    walkType: "访客进门",
  },
  "vistor-out": {
    walkType: "访客出门",
  },
};
export default {
  name: "epidemicStatistics",
  components: {
    pageHead,
  },
  data() {
    return {
      communityId: this.$store.state.streetorcommunityid || "",
      path: this.$store.state.path && this.$store.state.path.join("."),
      levelId: this.$store.state.level,
      head: "",
      height: "",
      query: {
        companyName: "",
        realName: "",
        phoneNO: "",
        minTemperature1: "",
        maxTemperature1: "",
        communityId: "",
      },
      comList: [],
      communityList: [], // 当前行政区域
      time: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      isLoading: false,
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "搜索",
          type: "search",
        },
        {
          name: "导出",
          type: "export",
        },
      ],
      tableHeader: [],
      tableData: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  mounted() {
    console.log(this.$store.state.path);
    console.log(this.$store.state.level);
    this.height = document.body.clientHeight - 60 - 90 - 40 - 30;
    var head = location.origin;
    if (head.indexOf("localhost") > -1) this.head = "http://shequyun.cn/";
    else this.head = head;
  },
  created() {
    this.getCommunity();
    this.initHeader();
    this.getWalkRecordList();
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.pageNum = 1;
        this.time = "";
        this.query.beginTime = "";
        this.query.endTime = "";
        this.comList = [];
        this.query.communityId = this.$store.state.streetorcommunityid;
        this.$refs.search.resetFields();
        this.getWalkRecordList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getWalkRecordList();
      } else {
        let {
          communityId,
          companyName,
          realName,
          phoneNO,
          minTemperature1,
          maxTemperature1,
        } = this.query;
        let minTemperature = minTemperature1
          ? parseInt(minTemperature1 * 10 * 10)
          : "";
        let maxTemperature = maxTemperature1
          ? parseInt(maxTemperature1 * 10 * 10)
          : "";
        let beginTime = "";
        let endTime = "";
        console.log(this.time);
        if (this.time[0]) {
          beginTime = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          endTime = this.$util.FormatDate(new Date(this.time[1]), "yyyy-MM-dd");
        }
        // console.log(communityId);
        let url =
          exportWalkRecordList +
          "?companyName=" +
          companyName +
          "&communityId=" +
          communityId +
          "&realName=" +
          realName +
          "&phoneNO=" +
          phoneNO +
          "&minTemperature=" +
          minTemperature +
          "&maxTemperature=" +
          maxTemperature +
          "&beginTime=" +
          beginTime +
          "&endTime=" +
          endTime +
          "&token=" +
          this.header.token;
        console.log(url);
        window.open(url);
      }
    },
    communityChange(value) {
      this.query.communityId = value[value.length - 1];
      console.log(this.query.communityId);
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770008,
      })
        .then((res) => {
          this.communityList = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: item.communityId,
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    pageChange(val) {
      this.pageNum = val;
      this.getWalkRecordList();
    },

    async getWalkRecordList() {
      this.isLoading = true;
      try {
        if (this.time[0]) {
          this.query.beginTime = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          this.query.endTime = this.$util.FormatDate(
            new Date(this.time[1]),
            "yyyy-MM-dd"
          );
        }
        this.query.minTemperature = this.query.minTemperature1
          ? parseInt(this.query.minTemperature1 * 10 * 10)
          : "";
        this.query.maxTemperature = this.query.maxTemperature1
          ? parseInt(this.query.maxTemperature1 * 10 * 10)
          : "";

        let res = await this.$get(getWalkRecordList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.query,
        });
        console.log(this.query);

        let list = res.rows.map((item) => ({
          ...item,
          ...WALKTYPEMAP[item.walkType],
          temperature: (item.temperature / 100).toFixed(2),
        }));
        // console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
    initHeader() {
      this.tableHeader = [
        {
          title: "序号",
          type: "index",
        },
        {
          title: "乡街",
          key: "streetName",
        },
        {
          title: "单位",
          key: "companyName",
        },
        {
          title: "姓名",
          key: "realName",
        },
        {
          title: "电话",
          key: "phoneNO",
        },
        {
          title: "出入时间",
          key: "createTime",
        },
        {
          title: "进门/出门",
          key: "walkType",
        },
        {
          title: "体温",
          key: "temperature",
        },
      ];
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #ff7b44;
}
.wrapper {
  min-height: 100%;
  padding-bottom: 30px;
}
.content {
  margin: 0 20px;
}
.iframebox {
  width: 100%;
  background: #fff;
}

.time {
  width: 100%;
}

.wrapper1 {
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 600px);
  margin-bottom: 10px;
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
}
</style>
